import ArrowBackIos from "@mui/icons-material/ArrowBackIos";
import React, { useEffect, useRef } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import ActivityDigestEmail from "../activity-digest-email/ActivityDigestEmail";

const mapStateToProps = state => ({
    ...state
});

function CreateDigest(props)
{
    const backButtonRef = useRef(null);

    useEffect(() => {
        backButtonRef.current?.focus();
    }, []);

    let goBack = () => {
        props.history.goBack();
    }

    return (<div>
        <div
            ref={backButtonRef}
            className="addDigestButton"
            tabIndex={0}
            onClick={goBack}
            onKeyDown={(e) => { if (e.key === 'Enter') goBack(); }}
        >
            <ArrowBackIos />
            Back
        </div>

        <ActivityDigestEmail frequency='DAILY' {...props} onCancelTab={() => backButtonRef.current?.focus()} />
    </div>);
}

export default withRouter(connect(mapStateToProps)(CreateDigest));